<template>
  <AnalysisPage pageName="tag" title="予約タグ" :disabled="busy || !chart(keepUnit)">
    <AnalysisContent :noSet="isMounted && !chart(keepUnit)">
      <template #unit>
        <Unit :refetch="fetch" :disabled="busy" />
      </template>
      <template #graph>
        <AnalysisAggregate :busy="busy" :refetch="fetch" />
        <FrameTemplate :busy="busy" :nodata="!chart(keepUnit)">
          <Chart
            type="LineChart"
            :data="chart(keepUnit)"
            :options="options"
            :unit="keepUnit"
            :yearMonths="isMonthly(keepUnit) ? hAxis : []"
          />
          <template #v-axis-unit>組</template>
          <template #year-labels v-if="isMonthly(keepUnit)"><YearLabels :yearMonths="hAxis"/></template>
          <template #h-axis-unit>{{ unitById[keepUnit] }}</template>
        </FrameTemplate>
      </template>
      <template #table>
        <TagTable />
      </template>
      <template #action>
        <Button small auto class="open" @click="itemSelectModal = true">表示する予約タグを設定</Button>
      </template>
      <template #no-set>予約タグが設定されていません<br />設定の予約タグ設定画面から設定してください</template>
    </AnalysisContent>
    <ItemSelectModal
      v-if="itemSelectModal"
      target="予約タグ"
      half
      :data="table.value"
      :selectedIds="table.selectedIds"
      @change="change"
      @close="itemSelectModal = false"
    />
  </AnalysisPage>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AnalysisPage from '@/components/templates/AnalysisPage'
import AnalysisContent from '@/components/molecules/AnalysisContent'
import AnalysisAggregate, { Unit } from '@/components/organisms/AnalysisAggregate'
import Button from '@/components/atoms/Button'
import Chart, { FrameTemplate, YearLabels } from '@/components/molecules/Chart'
import TagTable from './Components/TagTable'
import ItemSelectModal from './Components/ItemSelectModal'

export default {
  name: 'AnalysisTag',
  components: {
    AnalysisAggregate,
    AnalysisPage,
    AnalysisContent,
    FrameTemplate,
    Unit,
    Button,
    Chart,
    TagTable,
    ItemSelectModal,
    YearLabels,
  },
  data() {
    return {
      // TODO Storeで管理したい
      keepUnit: 0,
      itemSelectModal: false,
      isMounted: false,
    }
  },
  computed: {
    ...mapState({
      conditions: state => state.analysis.aggregate.conditions,
      busy: state => state.analysis.tag.busy,
      table: state => state.analysis.tag.table,
      unitById: state => state.analysis.unit.shortById,
    }),
    ...mapGetters({
      query: 'analysis/aggregate/query',
      chart: 'analysis/tag/chart',
      hAxis: 'analysis/tag/hAxis',
      chartColors: 'analysis/tag/chartColors',
      isMonthly: 'analysis/unit/isMonthly',
    }),
    options() {
      return {
        colors: this.chartColors,
      }
    },
  },
  watch: {
    $route() {
      this.fetch()
    },
    busy(newValue) {
      if (!newValue) {
        this.keepUnit = this.conditions.unit
      }
    },
  },
  async mounted() {
    await this.fetch()
    this.isMounted = true
  },
  methods: {
    async fetch() {
      const { dispatch } = this.$store
      const { unit, startTerm, endTerm } = this.query
      await dispatch('analysis/tag/get', {
        unit,
        startTerm,
        endTerm,
      })
    },
    change(ids) {
      this.$store.commit('analysis/tag/setSelectedIds', ids)
    },
  },
}
</script>

<style scoped lang="postcss">
.open {
  padding: 0 16px;
}
</style>
